import { useContext } from 'react';
import { AppContext } from '../AppProvider';

const useUser = () => {
    const {
        userData,
        isLoading
    } = useContext(AppContext);

    return {
        userData,
        isLoading
    };
};

export {
    useUser
};
